import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Skeleton,
} from '@mui/material';
import Row from 'components/Layout/Row';
import { Column } from 'further-ui/components/Layout';

const TransactionAllocatorSkeleton: React.FC = () => (
  <Accordion defaultExpanded disableGutters>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Row centered justify="space-between" fullWidth>
        <Skeleton variant="text" width={180} />
        <Skeleton variant="text" width={100} />
      </Row>
    </AccordionSummary>
    <AccordionDetails>
      <Column spacing="xs">
        <Row spacing="sm">
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
        </Row>
        <Row spacing="sm">
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
        </Row>
        <Row spacing="sm">
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
          <Skeleton variant="text" width="25%" />
        </Row>
      </Column>
    </AccordionDetails>
  </Accordion>
);

export default TransactionAllocatorSkeleton;
